package com.example.positionahead.util

import com.example.positionahead.model.PortfolioSummary
import kotlin.math.abs
import kotlin.math.round

fun formatCurrency(amount: Double): String {
    val sign = if (amount < 0) "-" else ""
    val absAmount = abs(amount)
    return when {
        absAmount >= 1_000_000 -> "$sign$${round(absAmount / 10_000) / 100}M"
        absAmount >= 10_000 -> "$sign$${round(absAmount / 10) / 100}K"
        else -> "$sign$${round(absAmount * 100) / 100}"
    }
}

fun formatPercent(value: Double, decimals: Int = 2): String {
    val factor = 10.0.pow(decimals)
    val rounded = round(value * factor) / factor
    val sign = if (rounded > 0) "+" else ""
    return "$sign$rounded%"
}

fun formatGainLoss(amount: Double, percent: Double, hasLivePrice: Boolean): String {
    if (!hasLivePrice) return "— (awaiting price)"
    return "${formatCurrency(amount)} (${formatPercent(percent)})"
}

/** Plan tab: show G/L whenever holdings have cost or market value (CSV + live or estimated quotes). */
fun formatPortfolioGainLoss(summary: PortfolioSummary): String {
    val hasData = summary.positions.any { it.costBasis > 0 || it.marketValue > 0 }
    if (!hasData) return "—"
    return "${formatCurrency(summary.totalUnrealizedGainLoss)} (${formatPercent(summary.totalUnrealizedGainLossPercent)})"
}

fun formatReturnPercentOptional(value: Double?): String =
    value?.let { formatPercent(it) } ?: "—"

fun scaleIncomeToPortfolioSize(income: Double, fromTotal: Double, toTotal: Double): Double {
    if (fromTotal <= 0 || toTotal <= 0) return income
    return income * (toTotal / fromTotal)
}

fun formatNumber(value: Double, decimals: Int = 2): String {
    val factor = 10.0.pow(decimals)
    return (round(value * factor) / factor).toString()
}

private fun Double.pow(n: Int): Double {
    var result = 1.0
    repeat(n) { result *= 10.0 }
    return result
}
